import { EmployeeViewFields } from '../models/EmployeeView';

export default {
  pageConfig: {
    name: 'Employees',
    label: 'Employees',
  },
  employeeStatusOptions: {
    ACTIVE: 'Active',
    BENCH: 'Bench',
    MILITARY_LEAVE: 'Military Leave',
    MATERNITY_LEAVE: 'Maternity Leave',
    SABBATICAL: 'Sabbatical',
    COMPASSIONATE_LEAVE: 'Compassionate leave',
    PARENTAL_DAYS: 'Parental days',
    REHIRED: 'Rehired',
    INACTIVE: 'Inactive',
  },
  employeeInfo: {
    syncEmployees: {
      title: 'Synchronize employees on dependent services'
    },
    insuranceBenefitReport: {
      title: 'Download Insurance benefit report',
      downloadError: 'Failed to download insurance benefit report'
    }
  },
  employeeDetails: {
    pageConfig: {
      name: 'Employee Details',
    },
    profileSection: {
      title: 'Profile',
      fullName: 'Full Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      dateOfBirth: 'Date of Birth',
      careerStartDate: 'Career Start Date',
      sex: 'Sex',
      status: 'Status',
      tenure: 'Tenure',
      tenureUnit: 'Years',
    },
    editDialog: {
      title: 'Edit Employee',
      editButton: 'Edit',
      save: 'Save',
      cancel: 'Cancel',
      none: 'None',
      sexOptions: {
        MALE: 'Male',
        FEMALE: 'Female',
      },
      notifications: {
        updateSuccess: 'Employee updated successfully',
        updateError: 'Failed to update employee',
      },
    },
    statusHistorySection: {
      title: 'Status History',
      createButton: 'Create record',
      columns: {
        startDate: { headerName: 'Start Date' },
        endDate: { headerName: 'End Date' },
        status: { headerName: 'Status' },
        reasonId: { headerName: 'Reason' },
        changeReasonType: { headerName: 'Change Type' },
        outcome: { headerName: 'Result' },
        comment: { headerName: 'Comment' },
        actions: { headerName: 'Actions' },
      },
      deleteDialog: {
        title: 'Delete status history record',
        description: 'Are you sure you want to delete the {{status}} status history record ({{startDate}} — {{endDate}})?',
        confirm: 'Delete',
      },
    },
    editStatusHistoryDialog: {
      title: 'Edit Status History Record',
      createTitle: 'Create Status History Record',
      editTitle: 'Edit Status History Record',
      startDate: 'Start Date',
      endDate: 'End Date',
      status: 'Status',
      reasonId: 'Reason',
      changeReasonType: 'Change Type',
      startDateRequired: 'Start date is required',
      endDateRequired: 'End date is required',
      statusRequired: 'Status is required',
      reasonIdRequired: 'Reason is required',
      endDateAfterStartDate: 'End date must be on or after start date',
      outcome: 'Result',
      comment: 'Comment',
      notifications: {
        createSuccess: 'Status history record created successfully',
        createError: 'Failed to create status history record',
        updateSuccess: 'Status history record updated successfully',
        updateError: 'Failed to update status history record',
        deleteSuccess: 'Status history record deleted successfully',
        deleteError: 'Failed to delete status history record',
      },
    },
    employmentSection: {
      title: 'Employment',
      editButton: 'Edit',
      startDate: 'Start Date',
      endDate: 'End Date',
      probationPeriodEndDate: 'Probation Period End Date',
      reason: 'Reason',
      changeReasonType: 'Change Type',
      alumni: 'Alumni',
      exitDetails: 'Exit Details',
      noExitDetails: 'No exit details',
      exitInterviewLink: 'Exit Interview Link',
      noExitInterviewLink: 'No exit interview link',
      noData: 'No employment data available',
      notifications: {
        updateError: 'Failed to update employment period',
      },
    },
  },
  benchPage: {
    pageConfig: {
      name: 'Bench',
      label: 'Bench',
    },
    filter: {
      from: 'From',
      to: 'To',
      combine: 'Combine by employee',
    },
    columns: {
      employeeId: { headerName: 'Employee ID' },
      photo: { headerName: 'Photo' },
      firstName: { headerName: 'First Name' },
      lastName: { headerName: 'Last Name' },
      isOver: { headerName: 'Status Over' },
      startDate: { headerName: 'Start Date' },
      endDate: { headerName: 'End Date' },
      reason: { headerName: 'Reason' },
      changeReasonType: { headerName: 'Change Type' },
      outcome: { headerName: 'Result' },
      comment: { headerName: 'Comment' },
    },
  },
  leavesPage: {
    pageConfig: {
      name: 'Leaves',
      label: 'Leaves',
    },
    filter: {
      status: 'Status',
      from: 'From',
      to: 'To',
      combine: 'Combine by employee',
    },
    columns: {
      employeeId: { headerName: 'Employee ID' },
      photo: { headerName: 'Photo' },
      firstName: { headerName: 'First Name' },
      lastName: { headerName: 'Last Name' },
      isOver: { headerName: 'Status Over' },
      startDate: { headerName: 'Start Date' },
      endDate: { headerName: 'End Date' },
      reason: { headerName: 'Reason' },
      changeReasonType: { headerName: 'Change Type' },
      outcome: { headerName: 'Result' },
      comment: { headerName: 'Comment' },
    },
  },
  onboardingPage: {
    pageConfig: {
      name: 'Onboarding',
      label: 'Onboarding',
    },
  },
  offboardingPage: {
    pageConfig: {
      name: 'Offboarding',
      label: 'Offboarding',
    },
    addExit: 'Add exit',
    filter: {
      eventType: 'Event',
      from: 'From',
      to: 'To',
      eventTypeOptions: {
        JOINED: 'Joined',
        LEFT: 'Left',
      },
    },
    columns: {
      employeeId: { headerName: 'Employee ID' },
      photo: { headerName: 'Photo' },
      firstName: { headerName: 'First Name' },
      lastName: { headerName: 'Last Name' },
      startDate: { headerName: 'Start Date' },
      endDate: { headerName: 'End Date' },
      probationPeriodEndDate: { headerName: 'Probation Period End Date' },
      projects: { headerName: 'Projects' },
      tenure: { headerName: 'Tenure (years)' },
      changeReason: { headerName: 'Exit reason' },
      changeReasonType: { headerName: 'Exit type' },
      alumni: { headerName: 'Alumni' },
      exitDetails: { headerName: 'Exit Details' },
      exitInterviewLink: { headerName: 'Exit Interview Link' },
      actions: { headerName: 'Actions' },
    },
    editDialog: {
      title: 'Edit Employment Period',
      employeeId: 'Employee',
      startDate: 'Start Date',
      endDate: 'End Date',
      probationPeriodEndDate: 'Probation Period End Date',
      changeReasonId: 'Exit reason',
      changeReasonType: 'Exit type',
      alumniId: 'Alumni',
      exitDetails: 'Exit Details',
      exitInterviewLink: 'Exit Interview Link',
      notifications: {
        updateSuccess: 'Employment period updated successfully',
        updateError: 'Failed to update employment period',
        noEmploymentPeriod: 'No employment period found for this employee',
      },
    },
    cancelClosingDialog: {
      title: 'Cancel closing',
      description: 'Are you sure you want to cancel closing the employment period for "{{firstName}} {{lastName}}"? This will clear the exit details.',
      confirm: 'Cancel closing',
    },
  },
  risksPage: {
    pageConfig: {
      name: 'Risk Management',
      label: 'Risk Management',
    },
    createButton: 'Create risk',
    columns: {
      id: { headerName: 'ID' },
      registrationDate: { headerName: 'Registration Date' },
      employee: { headerName: 'Employee' },
      lifecycleStage: { headerName: 'Lifecycle Stage' },
      riskLevel: { headerName: 'Risk Level' },
      riskType: { headerName: 'Risk Type' },
      mainReasons: { headerName: 'Main Reasons' },
      subReasons: { headerName: 'Sub Reasons' },
      teamExpectation: { headerName: 'Team Expectation' },
      cultureAlignment: { headerName: 'Culture Alignment' },
      nextSteps: { headerName: 'Next Steps' },
      keyConcerns: { headerName: 'Key Concerns' },
      documentLink: { headerName: '1-1 with Employee' },
      resolutionDate: { headerName: 'Resolution Date' },
      riskStatus: { headerName: 'Risk Status' },
      resolutionOutcome: { headerName: 'Resolution Outcome' },
      assignees: { headerName: 'Assignees' },
      comments: { headerName: 'Comments' },
      isExitCase: { headerName: 'Exit case' },
      employeeStatus: { headerName: 'Employee Status' },
      projects: { headerName: 'Projects' },
      actions: { headerName: 'Actions' },
    },
    riskTypeOptions: {
      VOLUNTARY: 'Voluntary',
      INVOLUNTARY: 'Involuntary',
    },
    editDialog: {
      createTitle: 'Create risk',
      editTitle: 'Edit risk',
      fields: {
        registrationDate: 'Registration Date',
        employeeId: 'Employee',
        lifecycleStageId: 'Lifecycle Stage',
        riskLevelId: 'Risk Level',
        riskType: 'Risk Type',
        mainReasonIds: 'Main Reasons',
        subReasonIds: 'Sub Reasons',
        teamExpectationId: 'Team Expectation',
        cultureAlignmentId: 'Culture Alignment',
        nextSteps: 'Next Steps',
        keyConcerns: 'Key Concerns',
        documentLink: '1-1 with Employee',
        resolutionDate: 'Resolution Date',
        riskStatusId: 'Risk Status',
        resolutionOutcomeId: 'Resolution Outcome',
        assigneeIds: 'Assignees',
        comments: 'Comments',
        isExitCase: 'Exit case',
      },
      validation: {
        employeeRequired: 'Employee is required',
        registrationDateRequired: 'Registration date is required',
        lifecycleStageRequired: 'Lifecycle stage is required',
        riskLevelRequired: 'Risk level is required',
        mainReasonsRequired: 'At least one main reason is required',
        teamExpectationRequired: 'Team expectation is required',
        cultureAlignmentRequired: 'Culture alignment is required',
        riskStatusRequired: 'Risk status is required',
        assigneeRequired: 'At least one assignee is required',
      },
      notifications: {
        createError: 'Failed to create risk',
        updateError: 'Failed to update risk',
        noEmploymentPeriod: 'No employment period found for this employee',
        employmentUpdateError: 'Failed to update employment period',
      },
    },
    deleteDialog: {
      title: 'Delete risk',
      description: 'Are you sure you want to delete the risk for "{{employeeName}}"?',
      confirm: 'Delete',
      notifications: {
        deleteError: 'Failed to delete risk',
      },
    },
  },
  configurationPage: {
    pageConfig: {
      name: 'Configuration',
      label: 'Configuration',
    },
    tabs: {
      changeReasons: 'Change Reasons',
      employeeStatuses: 'Employee Statuses',
      alumni: 'Alumni',
      riskLevel: 'Risk Level',
      riskReason: 'Risk Reason',
      lifecycleStage: 'Lifecycle Stage',
      expectation: 'Expectation',
      resolutionOutcome: 'Resolution Outcome',
      riskStatus: 'Risk Status',
    },
    statusesTitle: 'Statuses',
    riskReasonTypeOptions: {
      MAIN_REASON: 'Main Reason',
      SUB_REASON: 'Sub Reason',
    },
  },
  alumniPage: {
    createButton: 'Create alumni',
    columns: {
      id: { headerName: 'ID' },
      text: { headerName: 'Name' },
      color: { headerName: 'Color' },
      actions: { headerName: 'Actions' },
    },
    editDialog: {
      createTitle: 'Create alumni',
      editTitle: 'Edit alumni',
      text: 'Name',
      color: 'Color',
      textRequired: 'Name is required',
      notifications: {
        createError: 'Failed to create alumni',
        updateError: 'Failed to update alumni',
      },
    },
    deleteDialog: {
      title: 'Delete alumni',
      description: 'Are you sure you want to delete "{{text}}"?',
      confirm: 'Delete',
      notifications: {
        deleteError: 'Failed to delete alumni',
      },
    },
  },
  riskLevelsPage: {
    createButton: 'Create risk level',
    columns: {
      id: { headerName: 'ID' },
      text: { headerName: 'Name' },
      color: { headerName: 'Color' },
      actions: { headerName: 'Actions' },
    },
    editDialog: {
      createTitle: 'Create risk level',
      editTitle: 'Edit risk level',
      text: 'Name',
      color: 'Color',
      textRequired: 'Name is required',
      notifications: {
        createError: 'Failed to create risk level',
        updateError: 'Failed to update risk level',
      },
    },
    deleteDialog: {
      title: 'Delete risk level',
      description: 'Are you sure you want to delete "{{text}}"?',
      confirm: 'Delete',
      notifications: {
        deleteError: 'Failed to delete risk level',
      },
    },
  },
  riskReasonsPage: {
    createButton: 'Create risk reason',
    columns: {
      id: { headerName: 'ID' },
      text: { headerName: 'Name' },
      type: { headerName: 'Type' },
      color: { headerName: 'Color' },
      actions: { headerName: 'Actions' },
    },
    editDialog: {
      createTitle: 'Create risk reason',
      editTitle: 'Edit risk reason',
      text: 'Name',
      type: 'Type',
      color: 'Color',
      textRequired: 'Name is required',
      notifications: {
        createError: 'Failed to create risk reason',
        updateError: 'Failed to update risk reason',
      },
    },
    deleteDialog: {
      title: 'Delete risk reason',
      description: 'Are you sure you want to delete "{{text}}"?',
      confirm: 'Delete',
      notifications: {
        deleteError: 'Failed to delete risk reason',
      },
    },
  },
  lifecycleStagesPage: {
    createButton: 'Create lifecycle stage',
    columns: {
      id: { headerName: 'ID' },
      text: { headerName: 'Name' },
      color: { headerName: 'Color' },
      actions: { headerName: 'Actions' },
    },
    editDialog: {
      createTitle: 'Create lifecycle stage',
      editTitle: 'Edit lifecycle stage',
      text: 'Name',
      color: 'Color',
      textRequired: 'Name is required',
      notifications: {
        createError: 'Failed to create lifecycle stage',
        updateError: 'Failed to update lifecycle stage',
      },
    },
    deleteDialog: {
      title: 'Delete lifecycle stage',
      description: 'Are you sure you want to delete "{{text}}"?',
      confirm: 'Delete',
      notifications: {
        deleteError: 'Failed to delete lifecycle stage',
      },
    },
  },
  expectationsPage: {
    createButton: 'Create expectation',
    columns: {
      id: { headerName: 'ID' },
      text: { headerName: 'Name' },
      color: { headerName: 'Color' },
      actions: { headerName: 'Actions' },
    },
    editDialog: {
      createTitle: 'Create expectation',
      editTitle: 'Edit expectation',
      text: 'Name',
      color: 'Color',
      textRequired: 'Name is required',
      notifications: {
        createError: 'Failed to create expectation',
        updateError: 'Failed to update expectation',
      },
    },
    deleteDialog: {
      title: 'Delete expectation',
      description: 'Are you sure you want to delete "{{text}}"?',
      confirm: 'Delete',
      notifications: {
        deleteError: 'Failed to delete expectation',
      },
    },
  },
  resolutionOutcomesPage: {
    createButton: 'Create resolution outcome',
    columns: {
      id: { headerName: 'ID' },
      text: { headerName: 'Name' },
      color: { headerName: 'Color' },
      actions: { headerName: 'Actions' },
    },
    editDialog: {
      createTitle: 'Create resolution outcome',
      editTitle: 'Edit resolution outcome',
      text: 'Name',
      color: 'Color',
      textRequired: 'Name is required',
      notifications: {
        createError: 'Failed to create resolution outcome',
        updateError: 'Failed to update resolution outcome',
      },
    },
    deleteDialog: {
      title: 'Delete resolution outcome',
      description: 'Are you sure you want to delete "{{text}}"?',
      confirm: 'Delete',
      notifications: {
        deleteError: 'Failed to delete resolution outcome',
      },
    },
  },
  riskStatusesPage: {
    createButton: 'Create risk status',
    columns: {
      id: { headerName: 'ID' },
      text: { headerName: 'Name' },
      color: { headerName: 'Color' },
      actions: { headerName: 'Actions' },
    },
    editDialog: {
      createTitle: 'Create risk status',
      editTitle: 'Edit risk status',
      text: 'Name',
      color: 'Color',
      textRequired: 'Name is required',
      notifications: {
        createError: 'Failed to create risk status',
        updateError: 'Failed to update risk status',
      },
    },
    deleteDialog: {
      title: 'Delete risk status',
      description: 'Are you sure you want to delete "{{text}}"?',
      confirm: 'Delete',
      notifications: {
        deleteError: 'Failed to delete risk status',
      },
    },
  },
  changeReasonsPage: {
    pageConfig: {
      name: 'Change Reasons',
      label: 'Change Reasons',
    },
    filter: {
      scope: 'Scope',
      status: 'Status',
      scopeOptions: {
        STATUS: 'Status',
        EMPLOYMENT_PERIOD: 'Employment period',
      },
    },
    columns: {
      id: { headerName: 'ID' },
      reasonName: { headerName: 'Reason' },
      color: { headerName: 'Color' },
      scope: { headerName: 'Scope' },
      actions: { headerName: 'Actions' },
    },
    changeTypeOptions: {
      VOLUNTARY: 'Voluntary',
      INVOLUNTARY: 'Involuntary',
    },
    createButton: 'Create reason',
    editDialog: {
      createTitle: 'Create change reason',
      editTitle: 'Edit change reason',
      reasonName: 'Reason',
      statuses: 'Statuses',
      color: 'Color',
      reasonNameRequired: 'Reason is required',
      statusesRequired: 'At least one status is required',
      notifications: {
        createError: 'Failed to create change reason',
        updateError: 'Failed to update change reason',
      },
    },
    deleteDialog: {
      title: 'Delete change reason',
      description: 'Are you sure you want to delete "{{reasonName}}"?',
      confirm: 'Delete',
      notifications: {
        deleteError: 'Failed to delete change reason',
      },
    },
  },
  projectsPage: {
    pageConfig: {
      name: 'Projects',
      label: 'Projects',
    },
    columns: {
      id: { headerName: 'ID' },
      name: { headerName: 'Name' },
      status: { headerName: 'Status' },
      employeeCount: { headerName: 'Employees' },
      startDate: { headerName: 'Start Date' },
      endDate: { headerName: 'End Date' },
      actions: { headerName: 'Actions' },
    },
    statusOptions: {
      PLANNED: 'Planned',
      ACTIVE: 'Active',
      ON_HOLD: 'On Hold',
      TERMINATED: 'Terminated',
      DELIVERED: 'Delivered',
    },
    deleteDialog: {
      title: 'Delete project',
      description: 'Are you sure you want to delete the "{{name}}" project?',
      confirm: 'Delete',
      notifications: {
        deleteError: 'Failed to delete project',
      },
    },
  },
  employeesList: {
    columns: {
      [EmployeeViewFields.id]: {
        headerName: 'ID'
      },
      [EmployeeViewFields.fullName]: {
        headerName: 'Full Name'
      },
      [EmployeeViewFields.givenName]: {
        headerName: 'Given Name'
      },
      [EmployeeViewFields.familyName]: {
        headerName: 'Family Name'
      },
      [EmployeeViewFields.email]: {
        headerName: 'Email'
      },
      [EmployeeViewFields.photoUrl]: {
        headerName: 'Photo'
      },
      [EmployeeViewFields.isArchived]: {
        headerName: 'Archived'
      },
      [EmployeeViewFields.isAutoReportingEnabled]: {
        headerName: 'Auto Reporting'
      },
      [EmployeeViewFields.status]: {
        headerName: 'Status'
      },
      [EmployeeViewFields.tenure]: {
        headerName: 'Tenure (years)'
      },
      [EmployeeViewFields.startDate]: {
        headerName: 'Start Date'
      },
      [EmployeeViewFields.terminationDate]: {
        headerName: 'Termination Date'
      },
      [EmployeeViewFields.probationPeriodEndDate]: {
        headerName: 'Probation Period End Date'
      },
      [EmployeeViewFields.sex]: {
        headerName: 'Gender'
      },
      [EmployeeViewFields.dateOfBirth]: {
        headerName: 'Date of Birth'
      },
      [EmployeeViewFields.careerStartDate]: {
        headerName: 'Career Start Date'
      },
      [EmployeeViewFields.location]: {
        headerName: 'Location'
      },
    }
  }
};
